export const RogerPlatforms = {
  rpm: 'rpm',
  ccm: 'ccm',
} as const;

export const PlatformSelectOptions = [
  { label: 'RPM', value: RogerPlatforms.rpm },
  { label: 'CCM', value: RogerPlatforms.ccm },
];
